import React from 'react';

import Parametrage from '../../components/NewDashboard/Parametrage';

function SimplifiedSetupDashboardView() {
  return (
    <Parametrage />
  );
}

export default SimplifiedSetupDashboardView;



